import type { Lms } from "@verity/api-client/types";
import i18n from "../i18n";
import apiClient from "./api-client";

export function getLmsName(lms?: Lms) {
	if (lms) return i18n.t(`portal.portalTSX.${lms}`) as string;
	return undefined;
}

export function isLmsType(value?: string | null): value is Lms {
	return apiClient.lmsInfo.schemaValidators.lms.validate(value);
}
